const TEXT = {
   REMIND_TITLE:"待办提醒",

   remind_states: [
        {
          id: "0",
          name: "未读"
        },
        {
          id: "1",
          name: "已读"
        }
      ],
    iconlist:["","&#xe67c;","&#xe69c;","&#xe672;"],

};
export {
	TEXT
}


// WEBPACK FOOTER //
// ./src/config/page/cn/remind/index.js